export default "__VITE_ASSET__tOF9ZQ_i__"